const header = require('./includes/header')
const homepage = require('./pages/homepage');
const us = require('./pages/us')
const stuffs = require('./pages/stuffs')
const work = require('./pages/work')
const inside = require('./pages/inside')
const careers = require('./pages/careers')
const casePage = require('./pages/case');
const caseDetailPage = require('./pages/caseDetail');

$("document").ready(function () {
    header();
    homepage();
    us();
    stuffs();
    work();
    inside();
    careers();
    casePage();
    caseDetailPage();
    const lazyContent = new LazyLoad({});
})

$(window).resize(function () {

})
